<template>
    <templateList
        page-name="Lista de Filas"
        search-title="Filtrar Listas"
        search-input-placeholder="Digite o código, tipo ou nome da fila"
        add-button-text="Adicionar Fila"
        add-event="marketing-queues-list-new"
        search-event="marketing-queues-list-search"
        filters-apply-event="marketing-queues-list-filter"
        clear-filters-event="marketing-queues-list-clean-filters"
        menu-card-icon="fal fa-cog"
        @input="loadFilters"
    >

        <template #bradcrumbs>
            <ui-breadcrumbs design="full" :container="false">
                <template #left> Marketing &#8226; Lista de Filas </template>
            </ui-breadcrumbs>
        </template>

        <template #actions>
            <div class="button-link" @click="showMultipleChatCodeModal">
                <i class="fal fa-comment-alt-lines"/> <span>Gerar código para chat mútiplos</span>
            </div>
        </template>

        <template #content>
            <ui-data-table
                :columns="tableColumns"
                :per-page="20"
                :sort-by="{ value: 'createdLabel', dir: 'desc' }"
                :filters="tableFilterComputed"
                :control-fixed="true"
                :borders="true"
                name="marketingQueueList"
                service="lead"
                search-event="marketing-queues-list-search"
                tr-component="marketing/queue/table-line"
                not-found-icon="fal fa-user"
                not-found-text="Nenhuma Fila foi encontrada." />

            <ui-history-sidebar />
            <ui-chat-code-modal />
            <ui-multiple-chat-code-modal />
            <ui-form-link-modal />
            <ui-form-data-modal />
            <ui-whatsapp-script-to-link />

            <ui-modal-message
                name="marketing-queues-delete" 
                service="lead" 
                title="Deseja realmente excluir a fila?" 
                text="Cuidado, esta ação não poderá ser desfeita." 
                btn-type="danger" 
                btn-text="Confirmar"
                icon="fal fa-trash-alt"
                color-circle="danger"
                icon-circle />
        </template>
		
        <template #filters>
            <form>
                <template v-for="(filter, index) in filtersComputed">
                    <ui-date-range
                        v-if="filter.component === 'datepicker-range'"
                        :key="index" 
                        v-model="filter.model"
                        size="md"
                        :label="filter.label" />

                    <ui-select-2
                        v-else-if="filter.component === 'select-tags'"
                        :key="index"
                        v-model="filter.model"
                        size="md"
                        :data="filter.options"
                        return-value='value'
                        :label="filter.label"
                        :item-label="filter.itemLabel"
                        :search="filter.searchAble"
                        :multiple="filter.multiple" />
                </template>            
            </form>
        </template>

    </templateList>
</template>

<script>
    import templateList from '@/templates/page-list'

    import { uiBreadcrumbs, uiDataTable } from '@/components/ui'
    import { uiSelect2, uiDateRange } from '@/components/ui/form'
    import { uiModalMessage } from '@/components/ui/modal'

    import uiChatCodeModal from '../components/chat-code-modal'
    import uiFormLinkModal from '../components/form-link-modal'
    import uiFormDataModal from '../components/form-data-modal'
    import uiMultipleChatCodeModal from '../components/multiple-chat-code-modal'
    import uiHistorySidebar from '../components/sidebar-queues-history'
	import uiWhatsappScriptToLink from '../components/whatsapp-script-to-link'

    import { storage } from '@/services/storage'

    import helpers from '@/mixins/helpers'

    export default {
        name: 'ui-marketing-queues-list',

        components: {
            templateList,
            uiBreadcrumbs,
            uiDataTable,
            uiSelect2,
            uiDateRange,
            uiChatCodeModal,
            uiFormLinkModal,
            uiFormDataModal,
            uiMultipleChatCodeModal,
            uiHistorySidebar,
            uiModalMessage,
			uiWhatsappScriptToLink,
        },

        mixins: [helpers],

        data() {
            return {
                layout: {
                    showFiltersMenu: false,
                },
                tableColumns: [
                    {
                        title: 'Número',
                    },
                    {
                        title: 'Status',
                        data: 'lead_status',
                        sortable: true,
                    },
                    {
                        title: 'Tipo',
                        data: 'lead_type',
                        sortable: true,
                    },
                    {
                        title: 'Nome da Fila',
                        data: 'lead_name',
                        sortable: true,
                    },
                    {
                        title: 'Empreendimento',
                        data: 'product_name',
                        sortable: true,
                    },
                    {
                        title: 'Próximo da Fila',
                    },
                    {
                        title: 'Usuários',
                        data: 'users_total',
                        sortable: true,
                    },
                    {
                        title: 'Leads',
                        data: 'lead_leads',
                        sortable: true,
                    },
                    {
                        title: 'Último Lead',
                    },
                    {
                        title: 'Último Processamento',
                        data: 'customer_created_at',
                        sortable: true,
                    },
                    {
                        title: 'Atualização',
                        data: 'lead_updated_at',
                        sortable: true,
                    },
					{
						title: 'Data de Criação',
						data: 'lead_created_at',
						sortable: true,
					},
                    {
                        title: '',
                        class: 'control-xs',
                    },
                ],
                filters: [
                    {
                        component: 'datepicker-range',
                        label: 'Período',
                        model: '',
                        params: {
                            name: 'lead_created_at',
                            value: null
                        }
                    },
                    {
                        component: 'select-tags',
                        label: "Status",
                        disabled: false,
                        hidden: false,
                        itemLabel: 'name',
                        searchAble: false,
                        multiple: false,
                        options: [{
                            id: 1,
                            name: 'Ativo',
                            value: 'active'
                        }, {
                            id: 2,
                            name: 'Inativo',
                            value: 'inactive'
                        }],
                        model: '',
                        params: {
                            name: 'lead_status',
                            value: null
                        }
                    },
                    {
                        component: 'select-tags',
                        label: "Tipo",
                        disabled: false,
                        hidden: false,
                        itemLabel: 'name',
                        searchAble: false,
                        multiple: false,
                        options: [
                            {
                                id: 1,
                                name: 'Formulário',
                                value: 'form'
                            },
                            {
                                id: 2,
                                name: 'Integração',
                                value: 'integration'
                            },
                            {
                                id: 3,
                                name: 'Redistribuição',
                                value: 'redistribution'
                            }
                        ],
                        model: '',
                        params: {
                            name: 'lead_type',
                            value: null
                        }
                    },
                ]
            }
        },

        computed: {
            filtersComputed(){
                return this.filters.map(filter => {
                    return filter
                })
            },
            tableFilterComputed(){
                let data = this.filters.map(filter => {
                    let params = {...filter.params}

                    if ((['lead_type', 'lead_status']).includes(filter.params.name) && filter.model) {
                        params.value = filter.model
                    }

                    if (filter.params.name === 'lead_created_at' && filter.model) {
                        params.value = filter.model ? filter.model : ''
                    }

                    return params
                })

                return data
            }
        },

        mounted() {
            // Carrega as configurações à partir do localStorage
            const allowedMenu = storage.get('allowed_menu') || []

            // Verifica se o CallTracking e/ou o Chat está ativo
            if (allowedMenu.includes('chat')) {
                this.filters.findIndex((e, i) => {
                    if (e.params.name === 'lead_type') {
                        this.filters[i].options.push({
                            id: 4,
                            name: 'Chat',
                            value: 'chat'
                        })
                    }
                })
            }

            if (allowedMenu.includes('calltracking')) {
                this.filters.findIndex((e, i) => {
                    if (e.params.name === 'lead_type') {
                        this.filters[i].options.push({
                            id: 5,
                            name: 'Call Tracking',
                            value: 'calltracking'
                        })
                    }
                })
            }

            /**
             * Redireciona para o guia de cadastro de FILAS
             * */
            this.$root.$on('marketing-queues-list-new', () => {
                this.$router.push({ name: 'marketing.queues.add' })
            })

            this.$root.$on('modal-msg-marketing-queues-delete-response', () => {
                this.$root.$emit('marketing-queues-list-search')
            })

            this.$root.$on('marketing-queues-list-filter', () => {
                this.filters.map(res => {
                    res.params.value = res.model && res.model.value ? res.model.value : res.model
                })
                this.$root.$emit('marketing-queues-list-search')
            })

            this.$root.$on('marketing-queues-list-clean-filters', async () => {
                await this.resetFilters()
                this.$root.$emit('clear-all-dates')
                this.$root.$emit('marketing-queues-list-search')
            })
        },

        beforeDestroy() {
            this.$root.$off('marketing-queues-list-new')
            this.$root.$off('marketing-queues-list-search')
            this.$root.$off('marketing-queues-list-filter')
            this.$root.$off('marketing-queues-list-clean-filters')
            this.$root.$off('modal-msg-marketing-queues-delete-response')
        },

        methods: {
            loadFilters(filters) {
                if (filters) this.filters.map(res => {
                    res.params = filters.find(({ name }) => name == res.params.name)
                    res.model = res?.params?.value ? res.params.value : ''
                })
            },

            resetFilters() {
                for (const filter of this.filters) {
                    filter.params.value = ''
                    if (filter.component === 'select-tags') {
                        filter.model = ''
                    }
                    if (filter.component === 'datepicker-range'){
                        filter.model = ''
                    }
                }
            },

            showMultipleChatCodeModal() {
                this.$root.$emit('modal-open-marketing-queues-multiple-chat-code')
            },
        }
    }
</script>

<style lang="stylus" scoped>
    @import 'styles.styl'
</style>
